import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import { Button } from "@/shared/foundation/primitives";

import styles from "./SectionDeleteDialog.module.css";

export interface SectionDeleteDialogProps {
  /** Display title of the section being deleted. */
  title: string;
  /** How many cards the section contains — deleting the section deletes
   *  them all. */
  cardCount: number;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Confirmation dialog for deleting a dashboard section. Deleting a section
 * also deletes every card in it, so the body spells out the card count
 * before the user commits. Mirrors the ConfirmDeleteDialog in
 * `DashboardMenu.tsx`.
 */
export function SectionDeleteDialog({
  title,
  cardCount,
  onClose,
  onConfirm,
}: SectionDeleteDialogProps) {
  const name = title.trim();
  return (
    <Dialog open onClose={onClose}>
      <DialogTitle>Delete section</DialogTitle>
      <DialogContent>
        <div className={styles.dialogBody}>
          Delete {name ? <strong>{name}</strong> : "this section"}
          {cardCount > 0 &&
            ` and its ${cardCount} ${cardCount === 1 ? "card" : "cards"}`}
          ? This can&apos;t be undone.
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onConfirm}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
